import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { DynamicFormComponent } from "src/app/shared/forms/dynamic-form/dynamic-form.component";
import { ActionButtonConfig, ActionPanelConfig, ActionPanelOutput } from 'src/app/_models/common/form/form';
import { DynamicFormService } from '../../forms/dynamic-form/dynamic-form.service';
@Component({
    selector: 'app-action-panel',
    templateUrl: './action-panel.component.html',
    styleUrls: ['./action-panel.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ActionPanelComponent implements OnInit, OnChanges, OnDestroy {

  @ViewChild(DynamicFormComponent) dynamicForm: DynamicFormComponent;

  @Input("model")
  model: any;

  @Input("config")
  config: ActionPanelConfig;
  @Input("z_index_class")
  z_index_class: any;

  @Input("hideActionButtons")
  hideActionButtons: boolean;

  @Output()
  onSubmitPanel = new EventEmitter<any>();

  valueSubscription: Subscription;
  isFormInvalid: boolean = true;
  isFormDirty: boolean = false;
link = "https://www.youtube.com/embed?list=PLugzlMICZR8hcvfcGEtf9plQjk8_k_qNF";
  title: string = '';
  sub_title: string = '';
  selectedCount: number = 0;
  buttonModel: ActionButtonConfig[];
  notesRequired: boolean = false;
  formData: any;
  formModel: any;
  disableButtonsOnInvalid: boolean;
  isOverlay?: boolean = false;
  headerClass : string ='';

  constructor(private translate: TranslateService,
    private dynamicFormService: DynamicFormService) {
  }
  ngOnInit(): void {
  }

  ngOnDestroy() {
    if (this.valueSubscription) {
      this.valueSubscription.unsubscribe();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    this.initialize();
  }

  initialize() {
    if (this.config && this.config.headerTitle) {
      this.title = this.translate.instant(this.config.headerTitle);
      this.sub_title = this.config.subtitle != '' ? this.translate.instant(this.config.subtitle) : '';
      this.buttonModel = this.config.buttonConfig;

      this.disableButtonsOnInvalid = this.config.disableButtonsOnInvalid;
      this.isOverlay = this.config.isOverlay;
      this.headerClass = this.config.headerClass;
      if (this.config.isMultipleSelected) {
        this.selectedCount = this.config.selectedItemCount;
      }
      else {
        this.selectedCount = 0;
      }

      this.formData = this.config.formData;
      this.formModel = this.model;
      this.config.headerTitle === 'grade_copy' && (this.isFormDirty = true);
      if (this.valueSubscription) {
        this.valueSubscription.unsubscribe();
      }

      setTimeout(() => {
        this.valueSubscription = this.dynamicForm.form.valueChanges.subscribe(value => {
          this.isFormInvalid = !this.dynamicForm.form.dirty || this.dynamicForm.form.invalid;
          this.isFormDirty = this.dynamicForm.form.dirty;
        });
      }, 100);
    }
    else {
      this.title = '';
      this.selectedCount = 0;
      this.buttonModel = [];
      this.notesRequired = false;
      this.formData = null;
      this.formModel = null;
      this.isFormInvalid = true;
      this.isFormDirty = false;
    }
  }
  onClose(buttonKey) {
    let returnItems: ActionPanelOutput = {
      panelKey: this.config.panelKey,
      buttonKey: buttonKey,
      formModel: this.dynamicForm.form.value
    }
    this.onSubmitPanel.emit(returnItems);
  }

  onSubmit(item) {
    let buttonKey = item.key;
    let otherAction = item.otherAction?true:false;
    if (otherAction) {
      let returnItems: ActionPanelOutput = {
        panelKey: this.config.panelKey,
        buttonKey: buttonKey,
        formModel: this.dynamicForm.form.value
      }
      this.onSubmitPanel.emit(returnItems);
      return;
    }

    if(buttonKey != 'close'  && buttonKey != 'delete' && buttonKey != 'log'){
      if (this.dynamicForm.form.invalid) {
        this.dynamicFormService.onFormSubmitted(true);
        this.disableButtonsOnInvalid = true;
        this.isFormInvalid = true;
        return;
      }

      if (buttonKey == 'save') {
      this.dynamicFormService.onFormSubmitted(true);
      this.disableButtonsOnInvalid = true;
      this.isFormInvalid = true;
      }
    }

    let returnItems: ActionPanelOutput = {
      panelKey: this.config.panelKey,
      buttonKey: buttonKey,
      formModel: this.dynamicForm.form.value
    }
    this.onSubmitPanel.emit(returnItems);
  }

}
